/**
 * Private per-user profile notes (Discord "Заметка — видна только вам").
 * Local to this device — stored in localStorage, never sent to the server.
 * Keyed by the target user id.
 */
const KEY = 'bunker.userNotes.v1';

type Notes = Record<string, string>;

function load(): Notes {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Notes) : {};
  } catch {
    return {};
  }
}

export function getUserNote(userId: string): string {
  return load()[userId] ?? '';
}

export function setUserNote(userId: string, note: string): void {
  const notes = load();
  const trimmed = note.trim();
  if (trimmed) notes[userId] = note;
  else delete notes[userId];
  try {
    localStorage.setItem(KEY, JSON.stringify(notes));
  } catch {
    /* private mode — note is kept in the open editor for this session only */
  }
}
